import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import DoubleButton from '../components/DoubleButton';
import {connect} from 'react-redux'
import Dialog from 'components/Dialog';
import CriteriaForm from './CriteriaForm';
import useId from 'hooks/useId';

const style = theme => ({
    content: {
        marginTop: theme.spacing(2)
    },
    actions: {
        marginTop: theme.spacing(2)
    }
})

function NewCriteria(
    {
        classes,
        formSubmit,
        onClose,
        onAdd = () => {
        },
        initValues,
        partId,
        elementList,
        selectedItems,
        demandId,
        stageId,
        showParts
    }) {
    
    const formId = useId();

    const handleClose = () => {
        onClose();
    }

    const handleSubmit = () => {
        formSubmit[formId]()
    }

    const handleAdd = (values) => {
        onAdd(values);
    }

    return (
        <Dialog
            title={initValues ? Tr('edit_criterion') : Tr('new_criterion')}
            open={true}
            maxWidth={'md'}
            onClose={handleClose}
        >
            <CriteriaForm
                initValues={initValues}
                onSubmit={handleAdd}
                id={formId}
                partId={partId}
                elementList={elementList}
                selectedItems={selectedItems}
                demandId={demandId}
                stageId={stageId}
                showParts={showParts}
            />
            <div className={classes.actions}>
                {showParts && <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={initValues ? Tr('save') : Tr('add')}
                    onClickFirst={handleClose}
                    onClickSecond={handleSubmit}
                />}
            </div>
        </Dialog>
    )


}

NewCriteria.propTypes = {
    classes: PropTypes.any,
}

NewCriteria.defaultProps = {}

export default connect((state) => ({
    formSubmit: state.form
}), {})(withStyles(style)(NewCriteria));